import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { LocalAuthorityWardSnapshotResponse } from '../../api-models';
import { LocalAuthorityWardOptions } from '../../types/filters.type';

export default class GetLocalAuthorityWardSnapshot extends BaseAdapter<LocalAuthorityWardSnapshotResponse> implements AdapterInterface {
  rawResponse: LocalAuthorityWardSnapshotResponse;

  async adaptResponse(): Promise<LocalAuthorityWardOptions> {
    await this.fetchApiResponse('/api/local-authorities-and-wards-by-snapshot', HTTPMethod.Get);

    const adaptedResponse: LocalAuthorityWardOptions = {};

    Object.entries(this.rawResponse.snapshots).forEach(([snapshot, snapshotOptions]) => {
      adaptedResponse[snapshot] = {};
      Object.entries(snapshotOptions.local_authorities).forEach(([liftDataId, localAuthorityOption]) => {
        adaptedResponse[snapshot][liftDataId] = {
          localAuthorityName: localAuthorityOption.local_authority_name,
          wards: localAuthorityOption.wards.map((ward) => ({
            value: ward,
            label: ward === String(All.value) ? All.label : ward,
          })),
        };
      });
    });
    return adaptedResponse;
  }
}
